/* TLS account canon — conta.thelightstays.com e o dominio CANONICO da conta.
   As rotas /account* da loja 302'm pra conta nativa hospedada
   (shopify.com/98516566334) — formato aposentado em 2026-06-10.
   Este guard intercepta cliques em QUALQUER link /account* da pagina,
   inclusive dentro do shadow DOM do <shopify-account> (composedPath
   enxerga shadow root aberto), e reescreve pro dominio da casa.
   Excecao unica: /account/logout — esse encerra a sessao de STOREFRONT
   (carrinho/checkout) e precisa continuar local. */
(function () {
  'use strict';
  var CANON = 'https://conta.thelightstays.com';

  function rewrite(href) {
    if (!href) return null;
    if (href.indexOf('/account/logout') === 0) return null;
    if (href.indexOf('/account') === 0) return CANON + href;
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var path = e.composedPath ? e.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.tagName === 'A') {
          var target = rewrite(el.getAttribute('href'));
          if (target) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = target;
          }
          return;
        }
      }
    },
    true
  );
})();
